module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_7042.c3ebb887.png";